<nav aria-label="breadcrumb">
    <ol class="breadcrumb gap-2" [ngClass]="getClasses()" >
        @for (crumb of breadcrumbs(); track $index) {
            <li class="breadcrumb-item">
                <a [routerLink]="crumb.route" [queryParams]="crumb.params ?? null" class="btn-link text-secondary">{{ crumb.title }}</a>
            </li>
            <fa-icon [icon]="dividerIcon" class="text-secondary"></fa-icon>
        }
        <li class="breadcrumb-item active" [ngClass]="getClassesTitle()" aria-current="page">
            {{ currentPageTitle() }}
        </li>
    </ol>
</nav>
